export const seopricing = [
    {title:'how much does seo cost',url:'',},
{title:'how much does seo cost for small business uk',url:'',},
{title:'how much does seo cost uk',url:'',},
{title:'how much is seo per month uk',url:'',},
{title:'how much is seo uk',url:'',},
{title:'how to price seo',url:'',},
{title:'seo cost per month uk',url:'',},
{title:'seo pricing in uk',url:'',},
{title:'seo pricing uk',url:'',},
{title:'why is seo important for business',url:'',},
{title:'why use seo',url:'',},];